/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  BankAccountApiResource,
  ConflictErrorResponse,
  CreateBankAccountRequest,
  GetApiBankAccountList200,
  GetApiBankAccountListParams,
  NotFoundErrorResponse,
  PostApiBankAccountVerify400,
  UnauthorizedErrorResponse,
  UpdateBankAccountRequest,
  VerifyBankAccountRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBankAccountGetResponse200 = {
  data: BankAccountApiResource
  status: 200
}

export type getApiBankAccountGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBankAccountGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBankAccountGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBankAccountGetResponseSuccess = (getApiBankAccountGetResponse200) & {
  headers: Headers;
};
export type getApiBankAccountGetResponseError = (getApiBankAccountGetResponse401 | getApiBankAccountGetResponse403 | getApiBankAccountGetResponse404) & {
  headers: Headers;
};

export type getApiBankAccountGetResponse = (getApiBankAccountGetResponseSuccess | getApiBankAccountGetResponseError)

export const getGetApiBankAccountGetUrl = (id: number,) => {


  

  return `/api/bank-accounts/${id}`
}

export const getApiBankAccountGet = async (id: number, options?: RequestInit): Promise<getApiBankAccountGetResponse> => {
  
  return customFetch<getApiBankAccountGetResponse>(getGetApiBankAccountGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiBankAccountUpdateResponse200 = {
  data: BankAccountApiResource
  status: 200
}

export type putApiBankAccountUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiBankAccountUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiBankAccountUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiBankAccountUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiBankAccountUpdateResponseSuccess = (putApiBankAccountUpdateResponse200) & {
  headers: Headers;
};
export type putApiBankAccountUpdateResponseError = (putApiBankAccountUpdateResponse400 | putApiBankAccountUpdateResponse401 | putApiBankAccountUpdateResponse403 | putApiBankAccountUpdateResponse404) & {
  headers: Headers;
};

export type putApiBankAccountUpdateResponse = (putApiBankAccountUpdateResponseSuccess | putApiBankAccountUpdateResponseError)

export const getPutApiBankAccountUpdateUrl = (id: number,) => {


  

  return `/api/bank-accounts/${id}`
}

export const putApiBankAccountUpdate = async (id: number,
    updateBankAccountRequest: UpdateBankAccountRequest, options?: RequestInit): Promise<putApiBankAccountUpdateResponse> => {
  
  return customFetch<putApiBankAccountUpdateResponse>(getPutApiBankAccountUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateBankAccountRequest,)
  }
);}


export type deleteApiBankAccountDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiBankAccountDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiBankAccountDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiBankAccountDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiBankAccountDeleteResponseSuccess = (deleteApiBankAccountDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiBankAccountDeleteResponseError = (deleteApiBankAccountDeleteResponse401 | deleteApiBankAccountDeleteResponse403 | deleteApiBankAccountDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiBankAccountDeleteResponse = (deleteApiBankAccountDeleteResponseSuccess | deleteApiBankAccountDeleteResponseError)

export const getDeleteApiBankAccountDeleteUrl = (id: number,) => {


  

  return `/api/bank-accounts/${id}`
}

export const deleteApiBankAccountDelete = async (id: number, options?: RequestInit): Promise<deleteApiBankAccountDeleteResponse> => {
  
  return customFetch<deleteApiBankAccountDeleteResponse>(getDeleteApiBankAccountDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiBankAccountListResponse200 = {
  data: GetApiBankAccountList200
  status: 200
}

export type getApiBankAccountListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBankAccountListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBankAccountListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBankAccountListResponseSuccess = (getApiBankAccountListResponse200) & {
  headers: Headers;
};
export type getApiBankAccountListResponseError = (getApiBankAccountListResponse400 | getApiBankAccountListResponse401 | getApiBankAccountListResponse403) & {
  headers: Headers;
};

export type getApiBankAccountListResponse = (getApiBankAccountListResponseSuccess | getApiBankAccountListResponseError)

export const getGetApiBankAccountListUrl = (params?: GetApiBankAccountListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bank-accounts?${stringifiedParams}` : `/api/bank-accounts`
}

export const getApiBankAccountList = async (params?: GetApiBankAccountListParams, options?: RequestInit): Promise<getApiBankAccountListResponse> => {
  
  return customFetch<getApiBankAccountListResponse>(getGetApiBankAccountListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiBankAccountCreateResponse201 = {
  data: BankAccountApiResource
  status: 201
}

export type postApiBankAccountCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBankAccountCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBankAccountCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBankAccountCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiBankAccountCreateResponseSuccess = (postApiBankAccountCreateResponse201) & {
  headers: Headers;
};
export type postApiBankAccountCreateResponseError = (postApiBankAccountCreateResponse400 | postApiBankAccountCreateResponse401 | postApiBankAccountCreateResponse403 | postApiBankAccountCreateResponse409) & {
  headers: Headers;
};

export type postApiBankAccountCreateResponse = (postApiBankAccountCreateResponseSuccess | postApiBankAccountCreateResponseError)

export const getPostApiBankAccountCreateUrl = () => {


  

  return `/api/bank-accounts`
}

export const postApiBankAccountCreate = async (createBankAccountRequest: CreateBankAccountRequest, options?: RequestInit): Promise<postApiBankAccountCreateResponse> => {
  
  return customFetch<postApiBankAccountCreateResponse>(getPostApiBankAccountCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBankAccountRequest,)
  }
);}


export type postApiBankAccountSetDefaultResponse204 = {
  data: void
  status: 204
}

export type postApiBankAccountSetDefaultResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBankAccountSetDefaultResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBankAccountSetDefaultResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBankAccountSetDefaultResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBankAccountSetDefaultResponseSuccess = (postApiBankAccountSetDefaultResponse204) & {
  headers: Headers;
};
export type postApiBankAccountSetDefaultResponseError = (postApiBankAccountSetDefaultResponse400 | postApiBankAccountSetDefaultResponse401 | postApiBankAccountSetDefaultResponse403 | postApiBankAccountSetDefaultResponse404) & {
  headers: Headers;
};

export type postApiBankAccountSetDefaultResponse = (postApiBankAccountSetDefaultResponseSuccess | postApiBankAccountSetDefaultResponseError)

export const getPostApiBankAccountSetDefaultUrl = (id: number,) => {


  

  return `/api/bank-accounts/${id}/set-default`
}

export const postApiBankAccountSetDefault = async (id: number, options?: RequestInit): Promise<postApiBankAccountSetDefaultResponse> => {
  
  return customFetch<postApiBankAccountSetDefaultResponse>(getPostApiBankAccountSetDefaultUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


export type postApiBankAccountVerifyResponse200 = {
  data: BankAccountApiResource
  status: 200
}

export type postApiBankAccountVerifyResponse400 = {
  data: PostApiBankAccountVerify400
  status: 400
}

export type postApiBankAccountVerifyResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBankAccountVerifyResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBankAccountVerifyResponseSuccess = (postApiBankAccountVerifyResponse200) & {
  headers: Headers;
};
export type postApiBankAccountVerifyResponseError = (postApiBankAccountVerifyResponse400 | postApiBankAccountVerifyResponse401 | postApiBankAccountVerifyResponse404) & {
  headers: Headers;
};

export type postApiBankAccountVerifyResponse = (postApiBankAccountVerifyResponseSuccess | postApiBankAccountVerifyResponseError)

export const getPostApiBankAccountVerifyUrl = (id: string,) => {


  

  return `/api/bank-accounts/${id}/verify`
}

export const postApiBankAccountVerify = async (id: string,
    verifyBankAccountRequest: VerifyBankAccountRequest, options?: RequestInit): Promise<postApiBankAccountVerifyResponse> => {
  
  return customFetch<postApiBankAccountVerifyResponse>(getPostApiBankAccountVerifyUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyBankAccountRequest,)
  }
);}


export type postApiBankAccountCreateForUserResponse201 = {
  data: BankAccountApiResource
  status: 201
}

export type postApiBankAccountCreateForUserResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiBankAccountCreateForUserResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBankAccountCreateForUserResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBankAccountCreateForUserResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type postApiBankAccountCreateForUserResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiBankAccountCreateForUserResponseSuccess = (postApiBankAccountCreateForUserResponse201) & {
  headers: Headers;
};
export type postApiBankAccountCreateForUserResponseError = (postApiBankAccountCreateForUserResponse400 | postApiBankAccountCreateForUserResponse401 | postApiBankAccountCreateForUserResponse403 | postApiBankAccountCreateForUserResponse404 | postApiBankAccountCreateForUserResponse409) & {
  headers: Headers;
};

export type postApiBankAccountCreateForUserResponse = (postApiBankAccountCreateForUserResponseSuccess | postApiBankAccountCreateForUserResponseError)

export const getPostApiBankAccountCreateForUserUrl = (id: number,) => {


  

  return `/api/users/${id}/bank-accounts`
}

export const postApiBankAccountCreateForUser = async (id: number,
    createBankAccountRequest: CreateBankAccountRequest, options?: RequestInit): Promise<postApiBankAccountCreateForUserResponse> => {
  
  return customFetch<postApiBankAccountCreateForUserResponse>(getPostApiBankAccountCreateForUserUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBankAccountRequest,)
  }
);}


